import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-950 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 py-12 md:py-16">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-book-open-line text-2xl text-primary-400"></i>
              </div>
              <span className="font-heading text-lg text-background-50">香香漫画</span>
            </Link>
            <p className="text-sm leading-relaxed text-background-400">
              香香漫画网致力于为漫画爱好者提供韩漫、日漫、国漫免费在线阅读服务。海量漫画资源，下拉式追更，安全直达，追更不等待。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-background-50 mb-4 text-base">快速导航</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category?type=韩漫" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200">
                  韩漫专区
                </Link>
              </li>
              <li>
                <Link to="/category?type=日漫" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200">
                  日漫专区
                </Link>
              </li>
              <li>
                <Link to="/category?type=国漫" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200">
                  国漫专区
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-background-50 mb-4 text-base">推荐漫画</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/comic/comic-1" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200">
                  社内相亲
                </Link>
              </li>
              <li>
                <Link to="/comic/comic-2" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200">
                  我独自升级
                </Link>
              </li>
              <li>
                <Link to="/comic/comic-3" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200">
                  咒术回战
                </Link>
              </li>
              <li>
                <Link to="/comic/comic-5" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200">
                  斗罗大陆
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-background-50 mb-4 text-base">关于我们</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200">
                  品牌介绍
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200">
                  联系我们
                </Link>
              </li>
            </ul>
            <div className="flex items-center gap-3 mt-5">
              <a
                href="#"
                className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors duration-200"
                aria-label="微博"
                rel="nofollow"
              >
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a
                href="#"
                className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors duration-200"
                aria-label="微信"
                rel="nofollow"
              >
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a
                href="#"
                className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors duration-200"
                aria-label="QQ"
                rel="nofollow"
              >
                <i className="ri-qq-line text-sm"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-background-800 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; {currentYear} 香香漫画网 xiangxiangcomic.com 版权所有
          </p>
          <p className="text-xs text-background-500">
            本站所有漫画均来自网络，版权归原作者所有。如侵犯您的权益请联系我们删除。
          </p>
        </div>
      </div>
    </footer>
  );
}